// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/js/d98c1c8f409f271e5add.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"7f961d00369a50c6fec9","127":"df128ae1591e9d035e16","128":"8db1a7b4693986df61c5"}[chunkId] + ".chunk.js";
};